import "bootstrap/dist/css/bootstrap.min.css";
import React from 'react';

const SuccessPage = () => {

    return (
        <div>
            Thank you for providing ALAS with an update on your firm&rsquo;s access to DataView&#8482; CMB. Please allow up to one business day for ALAS personnel to review and process your request.
        </div>
    );
};

export default SuccessPage;